// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /notification-settings/get-team.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeNotificationSettingsGetTeamBody,
  typeNotificationSettingsGetTeamOutput200,
} from "../../sdk/notificationSettings/postNotificationSettingsGetTeam";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildNotificationSettingsGetTeamQueryKey(
  payload: typeNotificationSettingsGetTeamBody,
): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`teamId:${JSON.stringify(payload.teamId)}`);
  return [
    "post:notificationSettings:notificationSettingsGetTeam",
    "svc:notification-api",
    ...queryKeySegments,
  ];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeNotificationSettingsGetTeamOutput200,
    unknown,
    typeNotificationSettingsGetTeamOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useNotificationSettingsGetTeam(
  payload: typeNotificationSettingsGetTeamBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildNotificationSettingsGetTeamQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postNotificationSettingsGetTeam(payload),
    ...resolvedOptions,
  });
}
